import { render, staticRenderFns } from "./LlmFeedbackRating.vue?vue&type=template&id=754b31c0"
import script from "./LlmFeedbackRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./LlmFeedbackRating.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports